export const EVENT_STATUS = {
    LIVE: "LIVE",
    SCHEDULED: "SCHEDULED",
    COMING: "COMING",
    NOW_PLAYING: "NOW PLAYING",
};

export const SECTION_TYPES = {
    PARTNERS: "partners",
    EVENTS: "event",
    SPORTS: "sport",
    LEAGUES: "league",
    PLAYING_NEXT: "playing_next",
};

export const SECTION_TITLES = {
    CHANNELS: "Featured Live Channels",
    NEXT_ON_THIS_SCREEN: "Next On This Screen",
};

export const EVENT_TITLES = {
    [SECTION_TYPES.PARTNERS]: "Partners",
    [EVENT_STATUS.LIVE]: "Live",
    [EVENT_STATUS.COMING]: "Upcoming",
    [EVENT_STATUS.SCHEDULED]: "Scheduled",
    [EVENT_STATUS.NOW_PLAYING]: "Now Playing",
    [SECTION_TYPES.SPORTS]: "Sports",
    [SECTION_TYPES.LEAGUES]: "Leagues and Conferences"
};

export const SIDE_PANEL_ACTIONS = {
    REMOVE: "remove",
    ADD: "add",
    PLAY: "play",
};

export const SIDE_PANEL_BUTTON_TITLES = {
    [SIDE_PANEL_ACTIONS.REMOVE]: "Remove Event",
    [SIDE_PANEL_ACTIONS.ADD]: "Add Event",
    [SIDE_PANEL_ACTIONS.PLAY]: "Play Now",
};

export const CONTENT_TYPE = {
    LIVE_EVENT: "live_event",
    LIVE_CHANNEL: "live_channel",
};

export const FIRST_EVENT_KEY = "event-live-0";

export const UPCOMING_BADGE_LABEL = "UPCOMING";

export const PLAYING_NEXT_PLAY_PENDO_LABEL = `${SIDE_PANEL_BUTTON_TITLES[SIDE_PANEL_ACTIONS.PLAY]} - ${SECTION_TITLES.NEXT_ON_THIS_SCREEN}`;
